import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconProfileDelete: React.FC<IconProps> = ({ width = 73, height = 73 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 73 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="0.5" width="72" height="72" rx="36" fill="#FFECEC" />
            <path
                d="M21.5 26.642C21.5 25.8346 22.0756 25.18 22.7857 25.18L27.2261 25.1792C28.1084 25.1538 28.8867 24.5159 29.1869 23.5722C29.1948 23.5474 29.2039 23.5168 29.2364 23.4058L29.4278 22.753C29.5448 22.3527 29.6468 22.004 29.7896 21.6923C30.3535 20.461 31.3968 19.6059 32.6024 19.387C32.9076 19.3316 33.2308 19.3318 33.6018 19.3321H39.3985C39.7695 19.3318 40.0927 19.3316 40.3978 19.387C41.6035 19.6059 42.6468 20.461 43.2107 21.6923C43.3534 22.004 43.4555 22.3527 43.5725 22.753L43.7639 23.4058C43.7964 23.5168 43.8055 23.5474 43.8134 23.5722C44.1136 24.5159 45.0463 25.1546 45.9286 25.18H50.2143C50.9244 25.18 51.5 25.8346 51.5 26.642C51.5 27.4494 50.9244 28.104 50.2143 28.104H22.7857C22.0756 28.104 21.5 27.4494 21.5 26.642Z"
                fill="#FF1A1A"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M35.826 52.6654H37.174C41.8119 52.6654 44.1308 52.6654 45.6385 51.1888C47.1463 49.7123 47.3005 47.2902 47.609 42.4462L48.0535 35.4664C48.2209 32.838 48.3046 31.5239 47.5482 30.6911C46.7919 29.8583 45.5145 29.8583 42.9599 29.8583H30.0401C27.4854 29.8583 26.2081 29.8583 25.4518 30.6911C24.6954 31.5239 24.7791 32.838 24.9465 35.4664L25.391 42.4462C25.6995 47.2902 25.8537 49.7123 27.3615 51.1888C28.8692 52.6654 31.1881 52.6654 35.826 52.6654ZM41.9105 36.5747C41.9792 35.8516 41.478 35.2068 40.791 35.1345C40.1041 35.0622 39.4916 35.5897 39.4229 36.3128L38.5895 45.0848C38.5208 45.8078 39.022 46.4526 39.709 46.5249C40.3959 46.5972 41.0084 46.0697 41.0771 45.3466L41.9105 36.5747ZM32.209 35.1345C32.8959 35.0622 33.5084 35.5897 33.5771 36.3128L34.4105 45.0848C34.4792 45.8078 33.978 46.4526 33.291 46.5249C32.6041 46.5972 31.9916 46.0697 31.9229 45.3466L31.0895 36.5747C31.0208 35.8516 31.522 35.2068 32.209 35.1345Z"
                fill="#FF1A1A"
            />
        </svg>
    );
};

export default IconProfileDelete;
